import { defineStore } from 'pinia'

interface LogoState {
  isStatusViewInitialized: boolean
}

interface LogoActions {
  initializeStatusView: () => void
}

export const useLogoStore = defineStore<
  'logo',
  LogoState,
  Record<string, never>,
  LogoActions
>({
  id: 'logo',
  state: (): LogoState => ({
    isStatusViewInitialized: true,
  }),
  actions: {
    initializeStatusView() {
      this.isStatusViewInitialized = false
    },
  },
})
